import { templatesRegistry } from 'utils/templates';

export function initFbPixel(templateId) {
  const template = templatesRegistry.getConfig(templateId);
  const enableFbPixel = template?.enableFbPixel;
  const fbPixelId = template?.fbPixelId;

  if (!enableFbPixel) {
    window.fbq = null;
    return;
  }

  if (window.fbq) {
    const prevId = window.fbq?.getState?.()?.pixels[0]?.id;
    if (prevId === fbPixelId) {
      return;
    } else {
      window.fbq = null;
    }
  }

  const f = window;
  const b = document;
  const e = 'script';
  const v = `https://connect.facebook.net/en_US/fbevents.js`;
  let n;
  let t;
  let s;

  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);

  f.fbq('init', fbPixelId);
  f.fbq('track', 'PageView');
}
